export default "__VITE_ASSET__swFSvEkb__"